import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, Button, TextField, Box, Typography, useTheme } from '@mui/material';
import {useAuth} from "../../../AuthContext/authContext";
import {GoogleSignInButton} from "../../atoms/GoogleSignInButton/GoogleSignInButton";

export const RegistrationDialog = ({ isOpen, onClose }: { isOpen: boolean; onClose: (isClosed: boolean) => void }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { register, registrationError } = useAuth();
    const theme = useTheme();

    useEffect(() => {
        if (!isOpen) {
            setPassword('');
            setEmail('');
        }
    }, [isOpen]);

    const handleSubmit = async () => {
        try {
            const registrationResponse = await register(email, password);
            if(registrationResponse.data.registerUser.id) {
                onClose(true);
            }
        } catch (err) {
            console.error('Registration error:', err);
        }
    };

    const ErrorComponent = (
        <Typography variant='subtitle2' style={{ color: theme.palette.error.main }} mb={1}>
            {registrationError?.message}
        </Typography>
    );

    return (
        <Dialog open={isOpen} onClose={() => onClose(false)} style={{ padding: 0 }} aria-autocomplete='none'>
            <Typography variant='h6' component='p' mt={1.5} ml={'auto'} mr={'auto'}>
                Register
            </Typography>
            <DialogContent aria-autocomplete='none' style={{ paddingTop: '4px', paddingBottom: '8px', width: '300px' }}>
                <Box display='flex' flexDirection='column' justifyContent='space-between'>
                    {registrationError?.message && ErrorComponent}
                    <TextField
                        label='email address'
                        type='email'
                        variant='outlined'
                        style={{ marginTop: '4px' }}
                        onChange={(e) => setEmail(e.target.value)}
                        value={email || ''}
                    />
                    <TextField
                        style={{ marginTop: '12px' }}
                        label='password'
                        type='password'
                        variant='outlined'
                        onChange={(e) => setPassword(e.target.value)}
                        value={password || ''}
                    />
                    <Button style={{ marginTop: '16px', marginBottom: '16px' }} variant='contained' onClick={handleSubmit}>
                        Submit
                    </Button>
                    <GoogleSignInButton onClose={onClose} />
                </Box>
            </DialogContent>
        </Dialog>
    );
};
